import { IUser } from "../contexts/types";

export enum UserRole {
  OWNER = "OWNER",
  DEFAULT = "DEFAULT",
  LOYALTY_PROG_USER = "LOYALTY_PROG_USER",
}

export enum UserType {
  ADMIN = "ADMIN",
  STANDARD = "STANDARD",
  DEFAULT = "DEFAULT",
  BUSINESSPARTNER = "BUSINESSPARTNER",
  LEAD = "LEAD",
}

const OWNER_ROLE = UserRole.OWNER;

const NON_MEMBER_ROLES = new Set<string>([
  UserRole.OWNER,
  UserRole.DEFAULT,
  UserRole.LOYALTY_PROG_USER,
  "",
]);

export class RolePermissionManager {
  private userRole: string;
  private userId: string;

  constructor(user: IUser) {
    this.userRole = user.user_role || UserRole.DEFAULT;
    this.userId = user.user_identification || "";
  }

  isOwner(): boolean {
    return this.userRole === OWNER_ROLE;
  }

  isTeamMember(): boolean {
    return !NON_MEMBER_ROLES.has(this.userRole);
  }

  canModifyUser(
    targetUserId: string,
    _action: "profile" | "role" | "type"
  ): boolean {
    const isSelf = this.userId === targetUserId;
    if (isSelf && this.isTeamMember()) return false;
    return true;
  }
}

export const useRolePermissions = (user: IUser) => {
  const manager = new RolePermissionManager(user);
  return {
    isOwner: manager.isOwner(),
    isTeamMember: manager.isTeamMember(),
    canModifyUser: (
      targetUserId: string,
      action: "profile" | "role" | "type"
    ) => manager.canModifyUser(targetUserId, action),
    _manager: manager,
  };
};

export const isOwnerRole = (user: IUser): boolean => {
  return user.user_role === OWNER_ROLE;
};

export const getRestrictedRoutesForNonRoot = (): string[] => {
  return [
    "/control-panel/paymod",
    "/control-panel/partners",
    "/control-panel/monitoring",
    "/control-panel/system",
    "/control-panel/security",
    "/control-panel/ai-engine-monitoring",
    "/control-panel/providers",
  ];
};

export const isRouteRestrictedForNonRoot = (pathname: string): boolean => {
  const restrictedRoutes = getRestrictedRoutesForNonRoot();
  return restrictedRoutes.some((route) => pathname.startsWith(route));
};

export default useRolePermissions;
